import React from 'react';
import moment from 'moment';
import Attention from '../../ReusableComponents/Attention';
import PortalFormModal from './PortalFormModal';
import { usePortalMutation } from '../hooks';
const types = {
  booklet: 'Caderno',
  answers: 'Respostas do candidato',
  answer_key: 'Gabarito',
  scores: 'Notas e acertos',
  preliminary: 'Resultado preliminar',
  final: 'Resultado definitivo',
  essay: 'Redações e correções',
};
export default function ReleaseForm({ selection, item, onDone }) {
  const editing = item;
  const save = usePortalMutation('selecoes/' + selection.id + '/liberacoes');
  return (
    <PortalFormModal
      title={item ? 'Editar liberação de resultados' : 'Nova liberação de resultados'}
      onClose={onDone}
      busy={save.isLoading}
      allowed={save.allowed}
      error={save.error}
      onSubmit={(e) => {
        e.preventDefault();
        const f = new FormData(e.currentTarget),
          d = Object.fromEntries(f);
        d.enabled = f.has('enabled');
        d.position_id = d.position_id || null;
        for (const key of ['starts_at', 'ends_at'])
          d[key] = d[key] ? new Date(d[key]).toISOString() : null;
        save.mutate(d, {
          onSuccess: () => onDone(),
        });
      }}
    >
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Conteúdo
            <Attention />
          </span>
          <select
            className="form-control form-select"
            name="type"
            defaultValue={editing?.type}
            disabled={!!editing}
            required
          >
            {Object.entries(types).map(([v, t]) => (
              <option key={v} value={v}>
                {t}
              </option>
            ))}
          </select>
          {editing && <input type="hidden" name="type" value={editing.type} required />}
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Cargo
            <small className="text-muted">(opcional)</small>
          </span>
          <select
            name="position_id"
            className="form-control form-select"
            defaultValue={editing?.position_id || ''}
            disabled={!!editing}
          >
            <option value="">Todos</option>
            {selection.positions.map((p) => (
              <option key={p.id} value={p.id}>
                {p.title}
              </option>
            ))}
          </select>
          {editing && <input type="hidden" name="position_id" value={editing.position_id || ''} />}
        </label>
        {['starts_at', 'ends_at'].map((key) => (
          <label key={key} className="form-label">
            <span className="portal-field-label">
              {key === 'starts_at' ? 'Disponível a partir de' : 'Disponível até'}
              <small className="text-muted">(opcional)</small>
            </span>
            <input
              className="form-control"
              name={key}
              type="datetime-local"
              defaultValue={editing?.[key] ? moment(editing[key]).format('YYYY-MM-DDTHH:mm') : ''}
            />
          </label>
        ))}
      </div>

      <label className="portal-check">
        <input type="checkbox" name="enabled" defaultChecked={editing?.enabled ?? true} /> Habilitar
        conteúdo no período
      </label>
    </PortalFormModal>
  );
}
